const RETURN_URL_HOST = /(^|\.)usimsa\.com$/

/**
 * returnUrl 은 shop.usimsa.com 같은 외부 도메인일 수 있다.
 * 오픈 리다이렉트를 막기 위해 내부 경로이거나 *.usimsa.com 호스트일 때만 허용한다.
 */
const getSafeReturnUrl = (returnUrl: unknown): string | null => {
  if (typeof returnUrl !== 'string' || !returnUrl) return null

  // 프로토콜 상대 경로(//evil.com)는 외부 이동이므로 내부 경로로 보지 않는다
  if (returnUrl.startsWith('/')) return returnUrl.startsWith('//') ? null : returnUrl

  try {
    return RETURN_URL_HOST.test(new URL(returnUrl).hostname) ? returnUrl : null
  } catch {
    return null
  }
}

export default defineNuxtRouteMiddleware((to, from) => {
  const authStore = useAuthStore()
  const { userAuth, isLoginStatus } = storeToRefs(authStore)

  try {
    const token = userAuth.value
    const partnersKey = from.params.partner

    if (!token) return

    // 만료된 토큰이 남아있는 경우. 쿠키를 지우고 로그인 페이지를 그대로 보여준다
    if (!isLoginStatus.value) {
      userAuth.value = null
      return
    }

    const returnUrl = getSafeReturnUrl(to.query.returnUrl)
    if (returnUrl) {
      return navigateTo(returnUrl, { external: !returnUrl.startsWith('/') })
    }

    return navigateTo(partnersKey ? `/partners/${partnersKey}/user` : '/user')
  } catch (e) {
    console.warn('Middleware login error ', e)
  }
})
